import React, { Component } from 'react'

export default class SchedulePage extends Component {
  renderMonth (list, index) {
    const courses = list.courses
    return (
      <li  key={index}>
        <h3>{list.monthName}</h3>
        <ul>
          {courses.map((course) => {
            const dates = course.dates
            return dates.map((listCourse, index) => (this.renderCourse(listCourse, index, course)))
          })}
        </ul>
      </li>
    )
  }

  renderCourse (listCourse, index, course) {
    return (
      <li className='clear' key={index}>
        <span onClick={() => this.onCourseClick(course.id, course.index)}>{course.title}</span>
        <span>{listCourse.days}</span>
        <span>{listCourse.weekday}</span>
        <span>{course.local}</span>
        <span>{listCourse.observation}</span>
      </li>
    )
  }

  onCourseClick (selectedCourse, courseIndex) {
    return this.props.propsHistory.push({
      pathname: `/workshop-page/${courseIndex}/${selectedCourse}?schedule`
    })
  }

  render() {
    const data = this.props.scheduleAll

    return (
      <div className='schedule-container blue'>
        <ul>
          {data.map((list, index) => (this.renderMonth(list, index)))}
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/schedule/scheduleContent.js